<div class="edit-images-grid">
  <div ng-click="edit.imagePopup(file.downloadURL);" ng-repeat="file in edit.files">
    <div style="background-image: url({{file.downloadURL}})"></div>
  </div>
</div>
